import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";
import * as React from "react";

export const EditIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 20 20", ...rest } = props;

    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g>
                <g>
                    <path
                        fill="currentColor"
                        d="M7,17.16H2.87l0-4.27L13.17,2.57,17.4,6.8Zm-3-1.2H6.54L15.7,6.8,13.17,4.27,4.05,13.39Z"
                    />
                    <rect
                        fill="currentColor"
                        x="4.52"
                        y="12.46"
                        width="1.2"
                        height="4.78"
                        transform="translate(-8.92 7.81) rotate(-44.35)"
                    />
                    <rect
                        fill="currentColor"
                        x="12.66"
                        y="4.32"
                        width="1.2"
                        height="4.78"
                        transform="translate(-0.86 11.34) rotate(-44.99)"
                    />
                    <rect fill="none" width="20" height="20" />
                </g>
            </g>
        </SvgIcon>
    );
};
